import Header from 'components/RichProfile/MyAccount/AutoReplenishment/SubscriptionItem/components/Header/Header';

export default Header;
